import React, { useState } from "react";
import CardUsersTable from "components/Cards/CardUsersTable";
import CardUserForm from "components/Cards/CardUserForm";

export default function Users() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setSelectedUser(null);
    setShowForm(false);
  };

  const handleUserSaved = () => {
    setShowForm(false);
    setSelectedUser(null);
    // Trigger table refresh
    setRefreshKey((prev) => prev + 1);
  };

  const handleUserDeleted = () => {
    // Trigger table refresh
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <CardUsersTable
            key={refreshKey}
            color="light"
            onEdit={handleEdit}
            onUserDeleted={handleUserDeleted}
          />
        </div>
      </div>

      <CardUserForm
        user={selectedUser}
        isOpen={showForm}
        onClose={handleCloseForm}
        onSaved={handleUserSaved}
      />
    </>
  );
}
